import React, { Component } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import withContext from 'context/withContext';
import { IContext, IDispatch } from 'context/reducers';
import HeaderMenuDesktop from './HeaderMenuDesktop';
import HeaderMenuMobile from './HeaderMenuMobile';

type Props = {
  context: IContext;
};

class HeaderMenu extends Component<RouteComponentProps & Props> {
  nav: HTMLDivElement;

  menu: HTMLDivElement;

  menuToggle: HTMLDivElement;

  isMenuOpen: boolean;

  dispatch: IDispatch;

  constructor(props) {
    super(props);

    this.nav = null;
    this.menu = null;
    this.menuToggle = null;
    this.isMenuOpen = false;
    const { context } = this.props;
    this.dispatch = context.dispatch;
  }

  componentDidUpdate(prevProps): void {
    const { location } = this.props;
    if (location.pathname !== prevProps.location.pathname && this.isMenuOpen) {
      this.cleanHome();
    }
  }

  componentWillUnmount() {
    this.cleanHome();
  }

  handleMenuToggle = (e: MouseEvent): void => {
    e.preventDefault();
    this.isMenuOpen = !this.isMenuOpen;

    if (this.isMenuOpen) {
      document.body.classList.add('no-scroll-full-page');
      document.documentElement.classList.add('no-scroll-full-page');
    } else {
      document.body.classList.remove('no-scroll-full-page');
      document.documentElement.classList.remove('no-scroll-full-page');
    }

    this.handleMenu();
  };

  handleMenu = (): void => {
    this.menuToggle.setAttribute('aria-expanded', String(this.isMenuOpen));
    this.menu.hidden = !this.isMenuOpen;
    this.nav.classList.toggle('nav--open');
  };

  cleanHome = (): void => {
    this.isMenuOpen = false;
    this.menu.hidden = true;
    this.nav.classList.remove('nav--open');
    document.body.classList.remove('no-scroll-full-page');
    document.documentElement.classList.remove('no-scroll-full-page');
    this.dispatch({
      type: 'SELECT_DESTINATION',
      selectDestination: 'pacote',
    });
  };

  render() {
    return (
      <div
        id="HeaderMenu"
        ref={ref => {
          this.nav = ref;
        }}
      >
        <HeaderMenuDesktop cleanHome={this.cleanHome} />

        <HeaderMenuMobile
          refMenu={ref => {
            this.menu = ref;
          }}
          refMenuToggle={ref => {
            this.menuToggle = ref;
          }}
          handleMenuToggle={this.handleMenuToggle}
          cleanHome={this.cleanHome}
        />
      </div>
    );
  }
}

export default withContext(withRouter(HeaderMenu));
